import React from 'react';
import PropTypes from 'prop-types';
import DataService from 'lib/DataService';
import { translate } from 'react-i18next';

import UserContext from 'contexts/User';

import Brochure from 'components/Building/Brochures/Brochure';
import { sortMasterFirst, sortDefaultFirst } from 'components/Building/Brochures/lib';
import { Container as Placehoder } from 'components/Building/Brochures/Brochure/styles';

const Api = new DataService();

class AddToCollection extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			brochures: [],
			loading: true,
		}
	}

	componentDidMount() {
		this.mounted = true;

		Api.getBrochures(this.props.building)
			.then(res => {
				this.setState({
					brochures: res.result.brochures,
					loading: false,
				});
			})
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		const {
			t,
			collectionData,
			collectionHandler,
		} = this.props;

		return (
			<UserContext>
				{loggedUser => (
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						{
							this.state.loading && (
								<React.Fragment>
									{
										this.props.brochures.slice(0, 3).map((b, i) => {
											const style = i === this.props.brochures.length - 1 ? { marginRight: 0 } : {};
											return <Placehoder key={b} style={{ height: '227px', marginBottom: 0, ...style }} />
										})
									}
									<div style={{
										zIndex: 1,
										backgroundColor: 'rgba(255,255,255,0.25)',
										position: 'absolute',
										top: '0',
										left: '0',
										width: '100%',
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}>
										<h2>
											{t('browse/Loading brochures')}
										</h2>
									</div>
								</React.Fragment>
							)
						}
						{
							!this.state.loading && this.state.brochures.length === 0 &&
							<h2>{t('browse/No brochures')}</h2>
						}
						{
							this.state.brochures.sort(sortDefaultFirst).sort(sortMasterFirst).map((brochure, i) => {
								const brochureInCollection = collectionData && collectionData.brochures.includes(brochure.id);
								const canAddToCollection = loggedUser.can.create.collections();
								const style = i === this.state.brochures.length - 1 ? { marginRight: 0 } : {};

								return (
									<Brochure
										key={brochure.id}
										type={'tile'}
										brochure={brochure}
										collection={collectionData.locked ? false : collectionData}
										collectionHandler={collectionHandler}
										brochureInCollection={brochureInCollection}
										baseUrl={this.props.baseUrl}
										canShare={false}
										canAddToCollection={canAddToCollection}
										canClone={false}
										canRemove={false}
										cloneBrochureHandler={() => {}}
										deleteBrochureHandler={() => {}}
										shareBrochureHandler={() => {}}
										style={{ ...style }}
									/>
								)
							})
						}
					</div>
				)}
			</UserContext>
		)
	}
}

AddToCollection.propTypes = {
	t: PropTypes.func,
	baseUrl: PropTypes.string,
	building: PropTypes.string,
	brochures: PropTypes.array,
	collectionData: PropTypes.object,
	collectionHandler: PropTypes.func,
}

export default translate('translations')(AddToCollection)
